<template>
  <div
    id="app"
    :class="{ 'has-mouse': hasMouse }"
    @touchstart="hasMouse = false"
  >
    <flipbook
      v-slot="flipbook"
      ref="flipbook"
      class="flipbook"
      :zooms="zooms"
      :pages="pages"
      :pagesHiRes="pagesHiRes"
      :startPage="pageNum"
      v-on:flip-left-start="onFlipLeftStart()"
      v-on:flip-left-end="onFlipLeftEnd()"
      v-on:flip-right-start="onFlipRightStart()"
      v-on:flip-right-end="onFlipRightEnd()"
      v-on:zoom-start="onZoomStart()"
      v-on:zoom-end="onZoomEnd()"
    >
      <div class="action-bar">
        <FirstPageIcon
          class="btn left"
          v-bind:class="{ disabled: !flipbook.canFlipLeft }"
          v-on:click="flipToPage(1)"
          title="First page"
          id="firstpage_icon"
        />
        <LeftIcon
          class="btn left"
          v-bind:class="{ disabled: !flipbook.canFlipLeft }"
          v-on:click="flipbook.flipLeft"
          title="Previous page"
          id="left_icon"
        />
        <MinusIcon
          class="btn minus"
          v-bind:class="{ disabled: !flipbook.canZoomOut }"
          v-on:click="flipbook.zoomOut"
          title="Zoom out"
          id="minus_icon"
        />
        <span class="page-num"
          >{{ flipbook.page }} / {{ flipbook.numPages }}</span
        >
        <PlusIcon
          class="btn plus"
          v-bind:class="{ disabled: !flipbook.canZoomIn }"
          v-on:click="flipbook.zoomIn"
          title="Zoom in"
          id="plus_icon"
        />
        <RightIcon
          class="btn right"
          v-bind:class="{ disabled: !flipbook.canFlipRight }"
          v-on:click="flipbook.flipRight"
          title="Next page"
          id="right_icon"
        />
        <LastPageIcon
          class="btn right"
          v-bind:class="{ disabled: !flipbook.canFlipRight }"
          v-on:click="flipToPage(pages.length)"
          title="Last page"
          id="lastpage_icon"
        />
      </div>
    </flipbook>
  </div>
</template>

<script>
import Flipbook from "flipbook-vue";
import "vue-material-design-icons/styles.css";
import FirstPageIcon from "vue-material-design-icons/PageFirst";
import LeftIcon from "vue-material-design-icons/ChevronLeft";
import RightIcon from "vue-material-design-icons/ChevronRight";
import LastPageIcon from "vue-material-design-icons/PageLast";
import PlusIcon from "vue-material-design-icons/Plus";
import MinusIcon from "vue-material-design-icons/Minus";

const defTitle = 'Clima 21 Yearbook 2025';
const urlPrefix = 'https://www.clima21.gr/yearbook-2025';

export default {
  name: "app",
  components: {
    Flipbook,
    FirstPageIcon,
    LeftIcon,
    RightIcon,
    LastPageIcon,
    PlusIcon,
    MinusIcon,
  },
  data: () => {
    const _pages = [null];
    const _hiResPages = [null];

    // let urlParams = new URLSearchParams(window.location.search);
    // const pages = urlParams.get('pages');
    // const id = urlParams.get('id');

    // for(let i = 1; i<=pages; i++) {
    // 	const _p = i.toString().padStart(3, '0')
    // 	_pages.push(`/image/sx600/file/content/magazines/magazine_${id}/page_${_p}.jpg`)
    // 	_hiResPages.push(`/content/magazines/magazine_${id}/page_${_p}.jpg`)
    // }

    for (let i = 1; i <= 359; i++) {
      _pages[i] = `/pages/page-${i.toString().padStart(3, "0")}.jpg`;
      _hiResPages[i] = `/hiResPages/page-${i.toString().padStart(3, "0")}.jpg`;
    }

    return {
      pages: _pages,
      pagesHiRes: _hiResPages,
      hasMouse: true,
      pageNum: null,
      zooms: [1, 2],
    };
  },
  computed: {},
  mounted() {
    this.setPageFromHash();
  },
  methods: {
    flipToPage(page) {
      // not index mode
      if (page > this.$refs.flipbook.numPages) {
        console.error("Page out of range");
      }

      page = page - 1; // make the page indexed by 0

      let method = page > this.$refs.flipbook.currentPage ? "Right" : "Left"; // Direction to go
      let flips = Math.abs(page - this.$refs.flipbook.currentPage); // number of flips to do

      if (!this.$refs.flipbook.singlePage) {
        // If is not in single page mode, the flips are divided by 2 cause in each flip show 2 pages
        flips = Math.floor(flips / 2);
      }

      if (flips == 0) {
        // If flips is equal to 0 it means the page is already visible
        return;
      }

      if (flips > 1) {
        // If the target page is not the next or the previous one, make the flip faster
        this.flipDuration = 300;
      }

      this.$refs.flipbook[`flip${method}`](); // make the first flip
      flips--; //subtract one flip

      if (flips > 0) {
        let interval = setInterval(() => {
          if (this.$refs.flipbook[`canFlip${method}`]) {
            this.$refs.flipbook[`flip${method}`]();
            flips--;
            if (flips == 0) {
              clearInterval(interval);
              this.flipDuration = 1000;
            }
          }
        }, 100);
      }
    },
    onFlipLeftStart() {},
    onFlipLeftEnd() {
      window.location.hash = "#" + this.$refs.flipbook.page;
      window.gtag("event", "page_view", {
        page_title: `${defTitle} - Page ${this.$refs.flipbook.page}`,
        page_location: `${urlPrefix}/#${this.$refs.flipbook.page}`,
      });
    },
    onFlipRightStart() {},
    onFlipRightEnd() {
      window.location.hash = "#" + this.$refs.flipbook.page;
      window.gtag("event", "page_view", {
        page_title: `${defTitle} - Page  ${this.$refs.flipbook.page}`,
        page_location: `${urlPrefix}/#${this.$refs.flipbook.page}`,
      });
    },
    onZoomStart() {
      //console.log("zoom-start", zoom);
    },
    onZoomEnd() {
      //console.log("zoom-end", zoom);
    },
    setPageFromHash() {
      const n = parseInt(window.location.hash.slice(1), 10);
      if (isFinite(n)) this.pageNum = n;
      window.gtag("event", "page_view", {
        page_title: `${defTitle} - Page ${n}`,
        page_location: `${urlPrefix}/#${n}`,
      });
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  color: #ccc;
  overflow: hidden;
}

.action-bar {
  width: 100%;
  height: 30px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
}
.action-bar .btn {
  font-size: 30px;
  color: #999;
}
.action-bar .btn svg {
  bottom: 0;
}
.action-bar .btn:not(:first-child) {
  margin-left: 10px;
}
.has-mouse .action-bar .btn:hover {
  color: #ccc;
  filter: drop-shadow(1px 1px 5px #000);
  cursor: pointer;
}
.action-bar .btn:active {
  filter: none !important;
}
.action-bar .btn.disabled {
  color: #666;
  pointer-events: none;
}
.action-bar .page-num {
  font-size: 12px;
  margin-left: 10px;
}
.flipbook .viewport {
  width: 90vw !important;
  height: calc(100vh - 50px - 40px) !important;
}
.flipbook .bounding-box {
  box-shadow: 0 0 20px #000;
}
</style>
